import { RequestConfig } from '~/common/services/requests/types/RequestConfig';
import { TransformerSet } from '../../../contexts/RequestsContext/constants';
import { TemplateRoleContact } from '../../../types';
import { buildHeadersFromDocumentParams } from '../../documents/logic/buildHeadersFromDocumentParams';
import { DocumentParams } from '../../documents/types/DocumentParams';
import { ConstructGet } from '../../types/ConstructGet';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { SIGNATURE_BASE_PATH } from '../constants/signatureBasePath';

export const listSignatureTemplateRoleContacts = (
  constructGet: ConstructGet,
  roleId: string,
  documentParams: DocumentParams<'definition'>,
  params?: RequestConfig['params'],
): Promise<NonPaginatedResponse<TemplateRoleContact[]> | undefined> =>
  constructGet<NonPaginatedResponse<TemplateRoleContact[]>>(
    `${SIGNATURE_BASE_PATH}/for-role/${roleId}`,
    { headers: buildHeadersFromDocumentParams(documentParams), params },
    { transformerSet: TransformerSet.PreserveKeys },
  );
